export const locationHasModule = (locations = [], plan = '') => {
	for (let i = 0, len = locations.length; i < len; i++) {
		let location = locations[i];

		// noinspection JSUnresolvedVariable
		if (location.location_moduless && location.location_moduless.length > 0) {
			for (let i = 0, len = location.location_moduless.length; i < len; i++) {
				let {modules} = location.location_moduless[i];

				if (modules && modules.plan && modules.plan === plan) {
					return true;
				}
			}
		}
	}

	return false;
};

export const accountHasModule = (modules = [], plan = '') => {
	for (let i = 0, len = modules.length; i < len; i++) {
		let module = modules[i].modules;
		if (module && module.plan && module.plan === plan) {
			return true;
		}
	}
	return false;
};